import React, { Component } from 'react';
import globals from "../../globals";
import HelmetDefault from "../../layout/HelmetDefault";
import Hero from "../../modules/Hero/Hero";
import Banner from "../../modules/Banner";
import Features from "../../modules/Features/Features";
import Cubes from "../../modules/Cubes";
import TwinColumn from "../../modules/TwinColumn";
import BanterHeading from "../../elements/BanterHeading";
import Heading from "../../elements/Heading";
import InlineTextBlocks from "../../modules/InlineTextBlocks/InlineTextBlocks";
import PanelList from "../../modules/PanelList";
import PlainText from "../../modules/PlainText";
import animations from "./animations";
import RegisterInterestForm from "../../forms/RegisterInterestForm/RegisterInterestForm";

class UnifiedCommunications extends Component {

	constructor(props) {
        super(props);

		this.state = {
			title: '',
			subTitle: '',
			leadCopy: [],
			bannerTitle: '',
			bannerCopy: '',
			features: {
				price: '',
				leadCopy: [],
				items: []
			},
            form: {},
			tools: {
				items: []
			},
			twinColumn: {},
			innovativeFeatures: {
				items: []
			},
			inlineTextBlocks: {},
			panelList: {},
			reasons: {
				data: []
			},

			seoTitle: '',
			seoDescription: '',
			dataReceived: false
		};
	}

	componentDidMount() {
		this.getData();
	}

	componentWillUnmount() {
		animations.destroy(this.controller);
	}

	getData() {
		fetch('/api/voip/unified-communications')
			.then(result => result.json())
			.then((result) => {
				this.setState(result);
				this.setDataReceived();
				globals.animatePageIn(this.container);
				this.controller = animations.initialise(this.container);
			});
	}

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

	render() {
		const Heading1 = <BanterHeading title="myTelephony" />;
		const Heading2 = <BanterHeading title="Call recordings" />;
		const Circles = this.state.innovativeFeatures.items.map((value, key) => {
			return (
				<div className="circle" key={key} dangerouslySetInnerHTML={{__html: value}} />
			);
		});
		const Reasons = this.state.reasons.data.map((value, key) => {
			return (
				<PlainText data={value} key={key} />
			);
		});

		return (
			<div ref={(el) => this.container = el} style={{opacity: 0}}>
				<HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
				<Banner title="" newClass="reverse">
					<div className="row">
						<div className="col-xs-12 col-md-6 col-md-offset-3">
							<h4>{this.state.bannerTitle}</h4>
							<p dangerouslySetInnerHTML={{__html: this.state.bannerCopy}} />
						</div>
					</div>
				</Banner>
				<Features price={this.state.features.price} leadCopy={this.state.features.leadCopy} items={this.state.features.items} />
				<Cubes
					title={this.state.tools.title}
					subTitle={this.state.tools.subTitle}
					items={this.state.tools.items}
				/>
				<RegisterInterestForm
                    title={this.state.form.title}
                    subTitle={this.state.form.subTitle}
                    submitEvent="unifiedCommunicationsFormSubmit"
                    hjEvent="/voip/unified-communications/submit"
                    product="unified-comms"
                />
				<TwinColumn data={this.state.twinColumn} heading1={Heading1} heading2={Heading2}>
					<div className="inline-circles">
						<div className="row">
							<div className="col-xs-12 col-md-10 col-md-offset-1">
								<Heading title={this.state.innovativeFeatures.title} />
								<div className="circles">
									{Circles}
								</div>
							</div>
						</div>
					</div>
				</TwinColumn>
				<InlineTextBlocks data={this.state.inlineTextBlocks} dataReceived={this.state.dataReceived} />
				<PanelList data={this.state.panelList} />
				<div className="reasons">
					<div className="row">
						<div className="col-xs-12 col-md-10 col-md-offset-1">
							<Heading title={this.state.reasons.title} subTitle={this.state.reasons.subTitle} />
							{Reasons}
						</div>
					</div>
				</div>
			</div>
		);
	}

}

export default UnifiedCommunications;


// WEBPACK FOOTER //
// ./resources/assets/js/voip/UnifiedCommunications/UnifiedCommunications.js